import React from "react";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import Layout from "../../components/vendorManager/Layout";
import Table from "../../components/ui/Table";
import Modal from "../../components/ui/utils/Modal";
import Pagination from "../../components/ui/Pagination";
import usePaginate from "../../hooks/api/usePaginate";
import useModal from "../../hooks/ui/useModal";
import apiRequest from "../../utils/vendorManager/apiRequest";
import { getFileUrl } from "../../utils/helper";
import EditVendorSiteSetting from "../../components/vendorManager/setting/EditSetting";
import DeleteSetting from "../../components/vendorManager/setting/DeleteSetting";
import CreateSetting from "../../components/vendorManager/setting/CreateSetting";
import Button from "../../components/ui/utils/Button";

const VendorSiteSettings = () => {
  const {
    data,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    limit,
    setPage,
    fetchData,
    sort,
    setSorting,
  } = usePaginate({
    apiMethod: apiRequest.getVendorSetting,
    dataKey: "settings",
  });

  const { isOpen, openModal, closeModal, actionType } = useModal();

  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };

  return (
    <Layout>
      <Button
        onClick={() => openModal({ type: "add" })}
        variant="primary"
        isLoading={false}
      >
        <div className="flex items-center justify-center gap-3">
          <FaPlus />
          <p>Create Setting</p>
        </div>
      </Button>
      <div className="p-4 bg-white rounded">
        <Table
          headers={[
            { label: "Type", key: "type", sorting: true },
            { label: "Content", key: "content", sorting: false },
            { label: "Created At", key: "createdAt", sorting: true },
            { label: "Action", key: "action", sorting: false },
          ]}
          loading={loading}
          error={error}
          handleSort={handleSort}
          sort={sort}
          cols={4}
          renderRow={
            <tbody className="divide-y">
              {data?.map((setting) => (
                <tr key={setting._id}>
                  {/* TYPE */}
                  <td className="px-3 py-3 font-medium">
                    {setting.type}
                  </td>

                  {/* CONTENT */}
                  <td className="px-3 py-3">
                    {setting.image ? (
                      <img
                        src={getFileUrl(setting.image)}
                        alt={setting.type}
                        className="w-20 h-20 object-contain border rounded"
                      />
                    ) : setting.value ? (
                      <span className="text-gray-700">{setting.value}</span>
                    ) : (
                      <div className="flex flex-wrap gap-2 text-xs">
                        {setting.is_vat && (
                          <span className="px-2 py-1 rounded bg-blue-100 text-blue-700">
                            VAT
                          </span>
                        )}
                        {setting.is_cgst && (
                          <span className="px-2 py-1 rounded bg-green-100 text-green-700">
                            CGST
                          </span>
                        )}
                        {setting.is_sgst && (
                          <span className="px-2 py-1 rounded bg-purple-100 text-purple-700">
                            SGST
                          </span>
                        )}

                        {!setting.is_vat &&
                          !setting.is_cgst &&
                          !setting.is_sgst && (
                            <span className="text-gray-400">-</span>
                          )}
                      </div>
                    )}
                  </td>



                  <td className="px-3 py-3 text-xs text-gray-500">
                    {new Date(setting.createdAt).toLocaleDateString("en-IN")}
                  </td>

                  <td className="px-3 py-3">
                    <div className="flex justify-center gap-3">
                      <button
                        onClick={() =>
                          openModal({
                            type: "edit",
                            data: { state: setting },
                          })
                        }
                        className="text-primary"
                        title="Edit"
                      >
                        <FaEdit size={18} />
                      </button>
                      <button
                        onClick={() =>
                          openModal({
                            type: "delete",
                            data: { state: setting },
                          })
                        }
                        className="text-red-500"
                        title="Delete"
                      >
                        <FaTrashAlt size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
          />
        )}
      </div>

      <Modal isOpen={isOpen} onClose={closeModal} size="lg" overflow={"overflow-y-scroll"}>
        {actionType?.type === "add" && (
          <CreateSetting closeModal={closeModal} callback={fetchData} />
        )}
        {actionType?.type === "edit" && (
          <EditVendorSiteSetting
            data={actionType?.data?.state}
            closeModal={closeModal}
            callback={fetchData}
          />
        )}
        {actionType?.type === "delete" && (
          <DeleteSetting
            data={actionType?.data?.state}
            closeModal={closeModal}
            callback={fetchData}
          />
        )}
      </Modal>


    </Layout>
  );
};

export default VendorSiteSettings;
